import { api } from "./api";
import type { BatchEdit } from "./mutations";
import type { BatchResponse, EditableField, FieldValue, LoanSet } from "./types";
export interface PasteCell { id: string; name: string; field: EditableField; old: FieldValue; next: FieldValue; error?: string }
export interface PastePreview { cells: PasteCell[]; edits: BatchEdit[] }
export function previewResult(edits: BatchEdit[], result: BatchResponse): PastePreview {
  const cells: PasteCell[] = [];
  const valid: BatchEdit[] = [];
  for (const edit of edits) {
    const before = result.before?.find((l) => l.id === edit.loan.id) ?? edit.loan;
    const after = result.loans.find((l) => l.id === edit.loan.id);
    const set: LoanSet = {};
    for (const [field, value] of Object.entries(edit.set) as [EditableField, FieldValue][]) {
      const error = result.errors.find((e) => e.id === edit.loan.id && (e.field === null || e.field === field))?.message;
      const failed = error ?? (!after ? "This loan could not be updated" : undefined);
      const next = failed ? value : after![field] as FieldValue;
      cells.push({ id: edit.loan.id, name: before.file_name || "Untitled loan", field, old: before[field] as FieldValue, next, error: failed });
      if (!failed) set[field] = next;
    }
    if (Object.keys(set).length) valid.push({ loan: before, set });
  }
  return { cells, edits: valid };
}
export async function previewPaste(edits: BatchEdit[]): Promise<PastePreview> {
  const result = await api<BatchResponse>("/api/loans/batch/preview", { method: "POST", body: { batch_id: crypto.randomUUID(), edits: edits.map((e) => ({ id: e.loan.id, set: e.set })) } });
  return previewResult(edits, result);
}
